import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { tableHeaderSort } from '../helpers/TableHelpers';

class AccountPlayerFreePlaysHeader extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.target.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(this.props.id, sort, newOrder);
  }

  render() {
    const { t, meta } = this.props;
    const TABLE_HEADER = { 'created_at': t('accountPlayer.freePlaysHeader.date') };
    return (
      <thead>
        <tr>
          <th>{t('accountPlayer.freePlaysHeader.playType')}</th>
          <th>{t('accountPlayer.freePlaysHeader.domain')}</th>
          { tableHeaderSort('created_at', meta, TABLE_HEADER, this.onSortChange) }
          <th>{t('accountPlayer.freePlaysHeader.enteredText')}</th>
        </tr>
      </thead>
    );
  }
}

export default withTranslation()(AccountPlayerFreePlaysHeader);
